import React from 'react';
import { Home, Droplets, Zap, Paintbrush, Layers, Warehouse, BoxSelect, DoorOpen, Square, Trash2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  Home,
  Droplets,
  Zap,
  Paintbrush,
  Layers,
  Warehouse,
  BoxSelect,
  DoorOpen,
  Square,
  Trash2
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-[#c9a961]/10 text-[#c9a961] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Nos Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3C] mb-6">
            Une expertise tous corps d'état
          </h2>
          <p className="text-lg text-gray-600">
            De la conception à la réalisation, nous prenons en charge l'intégralité 
            de vos travaux de rénovation intérieure avec un savoir-faire reconnu.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-0 bg-white hover:-translate-y-2"
              >
                <CardContent className="p-8">
                  {/* Icon */}
                  <div className="mb-6 relative">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#c9a961] to-[#b89951] rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="text-white" size={32} />
                    </div>
                    <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-[#c9a961]/10 rounded-2xl -z-10"></div>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-[#0B1F3C] mb-3 group-hover:text-[#c9a961] transition-colors">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features List */}
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-2 text-sm text-gray-700">
                        <div className="w-1.5 h-1.5 bg-[#c9a961] rounded-full"></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-gradient-to-r from-[#0B1F3C] to-[#2a4a62] rounded-3xl p-12 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a961]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#c9a961]/10 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Un projet de rénovation en tête ?
            </h3>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Nos experts sont à votre écoute pour vous accompagner dans la réalisation 
              de votre projet, de A à Z.
            </p>
            <button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#c9a961] hover:bg-[#b89951] text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 inline-block"
            >
              Obtenir un devis gratuit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
